import { getGuideStep, getGuideRecommend, updateGuideTask } from '@/api/overseasGuide';

const FIRST_GUIDE_STEP = {
  'NOT_START': 0,
  'FINISH': 2
};

const TASK_FINISH_STATUS = 10;

export default {
  namespaced: true,
  state: {
    // 注册完成后新手问卷 - 功能引导
    firstGuideStep: null,
    guideTaskList: [],
    guideRecommendData: {},
    defaultShowGuideTask: false,
    screenRecorderDemoData: {},
    SubtaskDemoData: {}
  },
  mutations: {
    SET_FIRST_GUIDE_STEP(state, data) {
      state.firstGuideStep = data;
    },
    SET_GUIDE_TASK(state, data = []) {
      state.guideTaskList = data;
    },
    SET_GUIDE_RECOMMEND_DATA(state, data) {
      state.guideRecommendData = data;
    },
    SET_DEFAULT_SHOW_GUIDE_TASK(state, data) {
      state.defaultShowGuideTask = data;
    },
    SET_SCREEN_DEMO_DATA(state, data) {
      state.screenRecorderDemoData = data || {};
    },
    SET_SUBTASK_DEMO_DATA(state, data) {
      state.SubtaskDemoData = data || {};
    }
  },
  actions: {
    async  getFirstGuideStep({ commit }) {
      const guideStep = await getGuideStep({});
      commit('SET_FIRST_GUIDE_STEP', guideStep);
    },
    async getGuideInfo({ commit }) {
      const data = await getGuideRecommend({});
      commit('SET_GUIDE_RECOMMEND_DATA', data || {});
      commit('SET_GUIDE_TASK', data.questList);
      commit('SET_SCREEN_DEMO_DATA', data.demoIssueMap?.screen_record_demo_issue);
      commit('SET_SUBTASK_DEMO_DATA', data.demoIssueMap?.generate_subtask_demo_issue);
      return data;
    },
    async finishTask({ state, dispatch }, taskCode){
      if (!taskCode){
        return;
      }
      const task = state.guideTaskList.find(item => item.questCode === taskCode);
      if (!task || task.questStatus === TASK_FINISH_STATUS){
        return;
      }
      await updateGuideTask({ id: task.id, status: TASK_FINISH_STATUS });
      dispatch('getGuideInfo');
    }
  },
  getters:{
    isFinishFirstGuide (state) {
      return state.firstGuideStep >= FIRST_GUIDE_STEP.FINISH;
    }
  }
};


